export async function fetchBrainDashboard() {
  const r = await fetch('/api/brain-dashboard', { cache: 'no-store' });
  if (!r.ok) throw new Error(`brain-dashboard HTTP ${r.status}`);
  return r.json();
}
